import { ILookup } from '../common/interfaces/ILookup.interface';

export class ListBoxItem extends ILookup<number, string> {
    public selected: boolean;
    public isVisible: boolean;
    public isReadOnly: boolean;
    public additionalInfo?: string

    constructor(id = 0, text = '', isVisible = true, selected = false, isReadOnly = false) {
        super();
        this.id = id;
        this.text = text;
        this.isVisible = isVisible;
        this.selected = selected;
        this.isReadOnly = isReadOnly
    }
}
